<div class="content-wrapper">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
  
          <div class="card-body">
            <h4 class="card-title">Employees</h4>
       
            <div style="background: #ECECEC;padding:30px;">
                <div nz-row [nzGutter]="8">
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Function">
                           <!-- Department  -->
                            <select class="form-control" required [(ngModel)]="selectedDepartmentId" name="selectedDepartmentId"
                              id="selectedDepartmentId"   (change)="onFunctionChange($event)">
                              <option value="">-- Select Function --</option>
                              <option [value]="department.id" *ngFor="let department of Departments">{{department.name}}
                              </option>
                            </select>
                       
                    </nz-card>
                  </div>
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Request">
                    
                             <!-- Department  -->
                             <select class="form-control" required [(ngModel)]="contract" name="contract" #Erequest="ngModel"
                             (change)="onContractChange($event)">
                             <option value="">--Select Request--</option>
                             <option *ngFor="let request of Contracts" [ngValue]="request">{{request.reference}} </option>
                         </select>
                    </nz-card>
                  </div>
                  <div nz-col [nzSpan]="8">
                    <nz-card nzTitle="Select Status">
                          <!-- Statuses  -->
                          <select class="form-control" required [(ngModel)]="selectedStatus" name="selectedStatus"
                          id="selectedStatus"   (change)="onStatusChange($event)">
                          <option value="">-- Select Status --</option>
                          <option [value]="status.value" *ngFor="let status of Statuses">{{status.name}}
                          </option>
                        </select>
                    </nz-card>
                  </div>
                </div>
              </div>
            <div class="card">
  
              <p>Employee Count: {{size}}</p>
              <p-table #dt2 [value]="Employees" dataKey="id" [rows]="10" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10,25,50]" [loading]="loading" [paginator]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [(contextMenuSelection)]="UpdateEmployee"  
                [globalFilterFields]="['firstName','lastName','contractorName','locationName','departmentName','status']">
                <ng-template pTemplate="caption">
  
                    <div class="left-btn">
                        <input type="button" value="Export To Excel" (click)="exportExcel()" class="btn-primary"/>
                    </div>
                    <div class="right-btn">
                       
                        <div class="input-group">
                     

                            <input type="text" class="form-control" placeholder="search" aria-label="name"
                              (input)="dt2.filterGlobal($event.target.value, 'contains')">
                            <div class="input-group-append">
                              <button class="btn btn-sm btn-primary" type="button">Search</button>
                            </div>
                          </div>
                    </div>

                  <div class="form-group">
                   
                  </div>
                </ng-template>
  
                <ng-template pTemplate="header">
  
                  <tr>
                    <th>Reference</th>
                    <th>Name</th>
                    <th>Department</th>
                    <th>Contractor</th>
                    <th>Location</th>
                    <th>Active</th>
  
                  </tr>
  
                  <tr>
                    <th></th>
  
                    <th></th>
  
                    <th></th>
  
                    <th></th>
  
                    <th></th>
  
                    <th></th>
  
                  </tr>
  
                </ng-template>
  
                <ng-template pTemplate="body" let-data>
                  <tr  >
  
                    <td>
                      {{data.reference}}
                    </td>
  
                    <td>
                      <span class="image-text">{{data.firstName}} {{data.lastName}}</span>
                    </td>
  
                    <td>
                      <span class="image-text"> {{data.departmentName}}</span>
                    </td>
  
                    <td>
                      {{data.contractorName}}
                    </td>
  
                    <td>
                      {{data.locationName}}
                    </td>
  
                    <td [ngClass]="getStatusColor(data.isActive)"  >
                        {{data.isActive}}
                    </td>
  
  
  
                  </tr>
                </ng-template>
  
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5">No employee found.</td>
                  </tr>
                </ng-template>
  
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 
  
  <!-- Drawer -->
  <nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="720"
    [nzVisible]="ViewEmployeeVisible" nzTitle="Create" [nzFooter]="footerTpl" (nzOnClose)="close()">
  
    <!-- Side swipe content -->
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <h5 class="card-title">Employee Details</h5>
          <div class="card-body">
            <div class="row">
  
              <div class="col">
                <label><b>Name</b></label>
                <p>{{ UpdateEmployee?.firstName }} {{ UpdateEmployee?.lastName }}</p>
              </div>
  
              <div class="col">
                <label><b>Email</b></label>
                <p>{{ UpdateEmployee?.email }}</p>
              </div>
            </div>
  
            <div class="row">
  
              <div class="col">
                <label><b>Phone number</b></label>
                <p>{{ UpdateEmployee?.phoneNumber }}</p>
              </div>
  
              <div class="col">
                <label><b>Gender</b></label>
                <p>{{ UpdateEmployee?.gender }}</p>
              </div>
  
            </div>
  
            <div class="row">
  
              <div class="col">
                <label><b>Age</b></label>
                <p>{{ UpdateEmployee?.age }}</p>
              </div>
  
              <div class="col">
                <label><b>Address</b></label>
                <p>{{ UpdateEmployee?.address }}</p>
              </div>
  
            </div>
  
            <div class="row">
  
              <div class="col">
                <label><b>Qualification</b></label>
                <p>{{ UpdateEmployee?.qualification }}</p>
              </div>
  
              <div class="col">
                <label><b>Position</b></label>
                <p>{{ UpdateEmployee?.position }}</p>
              </div>
  
            </div>
  
            <div class="row">
  
              <div class="col">
                <label><b>Previous Employer</b></label>
                <p>{{ UpdateEmployee?.lastPlaceOfWork }}</p>
              </div>
  
              <div class="col">
                <label><b>Next of Kin</b></label>
                <p>{{ UpdateEmployee?.nextOfKin }}</p>
              </div>
  
            </div>
  
            <div class="row">
  
              <div class="col">
                <label><b>Next of Kin's Phone</b></label>
                <p>{{ UpdateEmployee?.nextOfKinPhone }}</p>
              </div>
  
              <div class="col">
                <label><b>Next of Kin's Address</b></label>
                <p>{{ UpdateEmployee?.nextOfKinAddress }}</p>
              </div>
  
            </div>
          </div>
  
          <hr>
  
          <!-- Non Editable View -->
          <div class="card-body">
  
            <div class="row">
  
              <div class="col">
                <label><b>Contract Reference</b></label>
                <p>{{ UpdateEmployee?.contractReference }}</p>
              </div>
  
              <div class="col">
                <label><b>Function</b></label>
                <p>{{ UpdateEmployee?.departmentName }}</p>
              </div>
            </div>

            <div class="row">

              <div class="col">
                <label><b>Request Location</b></label>
                <p>{{ UpdateEmployee?.locationName }}</p>
              </div>
  
              <div class="col">
                <label><b>Current Location</b></label>
                <p>{{ UpdateEmployee?.currentLocationName }}</p>
              </div>
            </div>
  
            <div class="row">
  
              <div class="col">
                <label><b>Cost Center</b></label>
                <p>{{ UpdateEmployee?.costCenterName }}</p>
              </div>
  
              <div class="col">
                <label><b>Contractor</b></label>
                <p>{{ UpdateEmployee?.contractorName }}</p>
              </div>
            </div>
  
            <div class="row">
  
              <div class="col">
                <label><b>Start Date</b></label>
                <p>{{ UpdateEmployee?.startDate | date: 'dd MMMM yyyy' }}</p>
              </div>
  
              <div class="col">
                <label><b>Expected End Date</b></label>
                <p>{{ UpdateEmployee?.endDate | date: 'dd MMMM yyyy' }}</p>
              </div>
  
            </div>
  
            <div class="row">
  
              <div class="col">
                <label><b> Class</b></label>
                <p>{{ UpdateEmployee?.employeeClass }}</p>
              </div>
  
              <div class="col">
                <label><b>Role Type</b></label>
                <p>{{ UpdateEmployee?.roleType }}</p>
              </div>
  
            </div>
  
            <div class="row">
              <div class="col" *ngIf="!edit">
                <label><b>Safety Induction</b></label>
                <p >Done</p>
                <p >Pending</p>
              </div>
  
              <div class="col" *ngIf="safetyOption && edit">
                <div class="form-group">
                  <label><b>Safety Induction</b></label>
                  <select class="form-control" required [(ngModel)]="safetyStatus" name="safetyStatus">
                    <option [ngValue]="false">Pending</option>
                    <option [ngValue]="true">Done </option>
                  </select>
                </div>
              </div>
            </div>
  
            <div class="row">
              <div class="col" >
                <label><b>Biometric Capture</b></label>
                <p  >Done</p>
                <p >Pending</p>
              </div>
  
              <div class="col">
                <div class="form-group">
                  <label><b>Biometric Capture</b></label>
                  <select class="form-control" required [(ngModel)]="biometricStatus" name="biometricStatus">
                    <option [ngValue]="false">Pending</option>
                    <option [ngValue]="true">Captured </option>
                  </select>
                </div>
              </div>
  
              <div class="col">
                <div class="form-group">
                  <label><b>Capture Date</b></label>
                  <nz-date-picker></nz-date-picker>
                </div>
              </div>
  
              <div class="col" >
                <!-- Biometric Officer  -->
                <div class="form-group">
                  <label for="bioOfficerName">Biometric Officer Name</label>
                  <input type="text" class="form-control" id="bioOfficerName" placeholder="Name" name="bioOfficerName"
                    [(ngModel)]="bioOfficerName" required>
                </div>
              </div>
              <div class="col" class="formControl" ></div>
            </div>
  
            <div class="row">
  
              <!-- Biometric start Date  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Biometric Start Date</label>
                  <input type="date" class="form-control" id="biometricstartdate" placeholder="" name="biometricstartdate"
                    [(ngModel)]="biometricstartdate" required>
                </div>
              </div>
  
              <!-- Biometric End Date Duration  -->
              <div class="col" >
                <div class="form-group">
                  <label for="exampleInputCity1">Biometric End Date</label>
                  <input type="date" class="form-control" id="biometricenddate" placeholder="" name="biometricenddate"
                    [(ngModel)]="biometricenddate" required>
                </div>
              </div>
  
            </div>
  
  
  
            <div class="table-responsive">
              <h5 class="card-title">Documents</h5>
              <table class="table table--striped table-hover">
                <thead>
                  <tr>
  
                    <th>
                      Document Name
                    </th>
                    <th>
                      Document Description
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let document of Documents" class="clickable">
  
                    <td>{{document.documentName}}</td>
                    <td>{{document.documentDescription}}</td>
  
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- Non Editable -->
      </div>
    </div>
  
    <!-- Side swipe content -->
  
    <ng-template #footerTpl>
      <div style="float: right">
       
  
     
  
        <button class="btn btn-warning" style="margin-right: 8px;" (click)="openDocuments()">Documents</button>
  
        <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;"
          (click)="close()">Cancel</button>
      </div>
    </ng-template>
  
  </nz-drawer>
 
  
 

  